<template lang="pug">
div
  b-row(v-show="isSubmitting")
    b-col
      b-card(class="py-5")
        loading(
          :active="true"
          :is-full-page="false"
          color="#498ceb"
        )
  Form(
    v-show="!isSubmitting",
    :data="document",
    :isSubmitting="isSubmitting",
    :showFileUpload="true",
    :fileRequired="false",
    @submit="create"
  )
</template>

<script>
import { ref } from '@vue/composition-api'
import Form from '../shared/Form.vue'
import useLibraryAdd from './useLibraryAdd'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    Form,
    Loading,
  },

  setup() {
    const { create, isSubmitting } = useLibraryAdd()

    const defaultFechaRevision = new Date()
    defaultFechaRevision.setMonth(defaultFechaRevision.getMonth() + 12)

    const document = ref({
      nombre: '',
      tipoDocumento: null,
      tematica: '',
      responsable: null,
      clientes: [],
      observaciones: '',
      fechaProximaRevision: defaultFechaRevision.toISOString().split('T')[0],
    })

    return {
      document,
      create,
      isSubmitting,
    }
  },
}
</script>
